// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dgrid-column-resizer {
	cursor: col-resize;
	position: absolute;
	width: 2px;
	background-color: #666;
	z-index: 1000;
}

.dgrid-resize-guard {
	cursor: col-resize;
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	top: 0;
}


.dgrid-resize-handle {
	height: 100px;
	width: 0;
	position: absolute;
	right: -4px;
	top:-4px;
	cursor: col-resize;
	z-index: 999;
	border-left: 5px solid transparent;
	outline: none;
}
html.has-ie-6 .dgrid-resize-handle {
	border-color: pink;
	filter: chroma(color=pink);
}
html.has-mozilla .dgrid .dgrid-resize-handle:focus,
html.has-opera .dgrid .dgrid-resize-handle:focus {
	/* Override focus outline style set in dgrid.css */
	outline: none;
}

.dgrid-resize-header-container {
	height:100%;
}

/* make the resize handles larger on touch-capable devices */
html.has-touch .dgrid-resize-handle {
	border-left: 20px solid transparent;
}
html.has-touch .dgrid-column-resizer {
	width: 2px;
}

html.has-no-quirks .dgrid-resize-header-container {
	/* set to relative so we can do the resizing against this node...
		except when in quirks mode, where we have to use the th */
	position: relative;
}
html.has-ie-6 .dgrid-resize-header-container {
	position: static; /* and in IE6 we have to do the th hack */
}
.dgrid-header .dgrid-cell-padding {
	overflow: hidden;
}
html.has-ie-6 .dgrid-header .dgrid-cell-padding {
	margin-right: 4px; /* for IE6, keep the resizer visible */
}
html.has-ie-6 .dgrid-header .dgrid-sort-arrow {
    margin-right: 0; /* for IE6, zero out the right margin due to the right margin for the container */
}
html.has-quirks .dgrid-header .dgrid-cell-padding, html.has-ie-6 .dgrid-header .dgrid-cell {
	position:relative;
}

#dgrid-css-extensions-ColumnResizer-loaded {
	display: none;
}
`, "",{"version":3,"sources":["webpack://./target/debug/2P/derived/ui/dgrid/css/extensions/ColumnResizer.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;CACV,sBAAsB;CACtB,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,QAAQ;CACR,MAAM;AACP;;;AAGA;CACC,aAAa;CACb,QAAQ;CACR,kBAAkB;CAClB,WAAW;CACX,QAAQ;CACR,kBAAkB;CAClB,YAAY;CACZ,kCAAkC;CAClC,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,0BAA0B;AAC3B;AACA;;CAEC,kDAAkD;CAClD,aAAa;AACd;;AAEA;CACC,WAAW;AACZ;;AAEA,4DAA4D;AAC5D;CACC,mCAAmC;AACpC;AACA;CACC,UAAU;AACX;;AAEA;CACC;2DAC0D;CAC1D,kBAAkB;AACnB;AACA;CACC,gBAAgB,EAAE,yCAAyC;AAC5D;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB,EAAE,sCAAsC;AAC1D;AACA;IACI,eAAe,EAAE,iFAAiF;AACtG;AACA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd","sourcesContent":[".dgrid-column-resizer {\n\tcursor: col-resize;\n\tposition: absolute;\n\twidth: 2px;\n\tbackground-color: #666;\n\tz-index: 1000;\n}\n\n.dgrid-resize-guard {\n\tcursor: col-resize;\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n}\n\n\n.dgrid-resize-handle {\n\theight: 100px;\n\twidth: 0;\n\tposition: absolute;\n\tright: -4px;\n\ttop:-4px;\n\tcursor: col-resize;\n\tz-index: 999;\n\tborder-left: 5px solid transparent;\n\toutline: none;\n}\nhtml.has-ie-6 .dgrid-resize-handle {\n\tborder-color: pink;\n\tfilter: chroma(color=pink);\n}\nhtml.has-mozilla .dgrid .dgrid-resize-handle:focus,\nhtml.has-opera .dgrid .dgrid-resize-handle:focus {\n\t/* Override focus outline style set in dgrid.css */\n\toutline: none;\n}\n\n.dgrid-resize-header-container {\n\theight:100%;\n}\n\n/* make the resize handles larger on touch-capable devices */\nhtml.has-touch .dgrid-resize-handle {\n\tborder-left: 20px solid transparent;\n}\nhtml.has-touch .dgrid-column-resizer {\n\twidth: 2px;\n}\n\nhtml.has-no-quirks .dgrid-resize-header-container {\n\t/* set to relative so we can do the resizing against this node...\n\t\texcept when in quirks mode, where we have to use the th */\n\tposition: relative;\n}\nhtml.has-ie-6 .dgrid-resize-header-container {\n\tposition: static; /* and in IE6 we have to do the th hack */\n}\n.dgrid-header .dgrid-cell-padding {\n\toverflow: hidden;\n}\nhtml.has-ie-6 .dgrid-header .dgrid-cell-padding {\n\tmargin-right: 4px; /* for IE6, keep the resizer visible */\n}\nhtml.has-ie-6 .dgrid-header .dgrid-sort-arrow {\n    margin-right: 0; /* for IE6, zero out the right margin due to the right margin for the container */\n}\nhtml.has-quirks .dgrid-header .dgrid-cell-padding, html.has-ie-6 .dgrid-header .dgrid-cell {\n\tposition:relative;\n}\n\n#dgrid-css-extensions-ColumnResizer-loaded {\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
